import Vue from 'vue';
import noty from './noty.service';

export default {
  async getSettingsByClient(clientId) {
    return (await Vue.http.get(`/api/hdraces/settings/byclient/${clientId}`)).data;
  },
  async save(clientId, hdRacesSettings) {
    await Vue.http.post(`/api/hdraces/settings/byclient/${clientId}`, hdRacesSettings);
    noty.success('Settings saved successfully');
  },
  async get(filter) {
    return (await Vue.http.post('/api/hdraces/tickets/list', filter)).data;
  }
}



// WEBPACK FOOTER //
// ./src/services/hdraces.service.js